// opervex-frontend/src/routes/financialRoutes.js

import Accounts from "../pages/Financial/Accounts";
import Categories from "../pages/Financial/Categories";
import Entry from "../pages/Financial/Entry";

const financialRoutes = [
  // Accounts
  { path: "Financial/Accounts", private: true, component: <Accounts /> },
  { path: "Financial/Accounts/:id", private: true, component: <Accounts /> },

  // Entries
  { path: "Financial/Entries", private: true, component: <Entry /> },
  { path: "Financial/Entries/:id", private: true, component: <Entry /> },

  // Entries
  { path: "Financial/Categories", private: true, component: <Categories /> },
  { path: "Financial/Categories/:id", private: true, component: <Categories /> },
];

export default financialRoutes;
